import { render } from "./tw-charts.vue?vue&type=template&id=257a4a4b"
import script from "./tw-charts.vue?vue&type=script&lang=js"
export * from "./tw-charts.vue?vue&type=script&lang=js"
script.render = render

export default script